import { ChangeEvent } from 'react';
import { TileHeader } from '@creditflowresearch/uilib/Tile';
import IconLock from '@creditflowresearch/uilib/Icon/IconLock';
import TitleWithIcon from '@creditflowresearch/uilib/TitleWithIcon';
import SearchInput from '@/creditflowresearch/ui/common/components/molecules/SearchInput';
import { getTrimmedString } from '@/creditflowresearch/ui/common/helpers/getTrimmedString';
import { useRoadshowsTileContext } from '@/creditflowresearch/application/Roadshows/RoadshowsTileContext';

import styles from './roadshowsTile.module.scss';

const RoadshowsTileHeader = () => {
  const { searchValue, setSearchValue, debouncedSearch } = useRoadshowsTileContext();

  const onSearchChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(value);
    const filteredValue = getTrimmedString(value);

    if (filteredValue === null) return;

    debouncedSearch(filteredValue);
  };

  return (
    <TileHeader
      title={ (
        <TitleWithIcon
          title="Roadshow Monitor"
          tooltipContent="Available for Investors only"
          icon={ IconLock }
          dataTest="roadshowsTileTitle"
        />
      ) }
      dataTest="roadshowsTileHeader"
    >
      <SearchInput
        formFieldClassName={ styles.searchInputField }
        placeholder="Filter by Name or Company"
        dataTest="roadshowsTileSearchInput"
        onChange={ onSearchChange }
        value={ searchValue }
      />
    </TileHeader>
  );
};

export default RoadshowsTileHeader;
